import {
  contractorMonitoringPerformanceTestStatusOptions,
  deviceAccessoriesOptions,
  deviceSystemTypeOptions,
  deviceWorkStatusOptions,
} from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { CustomerEmail } from "components/table/columnComponents/CustomerEmail"
import { CustomerName } from "components/table/columnComponents/CustomerName"
import { StatusOfPerformanceTest } from "components/table/columnComponents/StatusOfPerformanceTest"
import { StatusOfWork } from "components/table/columnComponents/StatusOfWork"

export const enterpriseMonitoringTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "",
    type: "checkbox",
    name: "checkbox",
    size: "mini",
    cellComponent: "checkbox",
  },
  {
    title: "Email",
    type: "sort-search",
    name: "email",
    size: "middle",
    cellComponent: CustomerEmail,
  },
  {
    title: "Contractor",
    type: "sort-search",
    name: "contractor_name",
    size: "middle",
  },
  {
    title: "Work Status",
    type: "select",
    name: "work_status",
    size: "small",
    options: deviceWorkStatusOptions,
    cellComponent: StatusOfWork,
  },
  {
    title: "Status",
    type: "select",
    name: "perftest_status",
    size: "small",
    options: contractorMonitoringPerformanceTestStatusOptions,
    cellComponent: StatusOfPerformanceTest,
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
    size: "small",
  },
  {
    title: "Zip code",
    type: "sort-search",
    name: "zip_code",
    size: "small",
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
    size: "small",
  },
  {
    title: "City",
    type: "sort-search",
    name: "city",
    size: "middle",
  },
  {
    title: "Customer",
    type: "sort-search",
    name: "homeowner_name",
    size: "middle",
    cellComponent: CustomerName,
  },
  {
    title: "Thermostat S/N",
    type: "sort-search",
    name: "sn",
    size: "middle",
  },
  {
    title: "Activation date",
    type: "sort-date-range",
    name: "activation_date",
    size: "middle",
  },
  {
    title: "Thermostat name",
    type: "sort-search",
    name: "name",
    size: "middle",
  },
  {
    title: "System type",
    type: "select",
    name: "system_type",
    size: "small",
    options: deviceSystemTypeOptions,
  },
  {
    title: "Accessories",
    type: "select",
    name: "accessories",
    size: "small",
    options: deviceAccessoriesOptions,
  },
  {
    title: "HVAC",
    type: "sort-search-number",
    name: "system_age",
    size: "small",
  },
]
